import { PrimeReactProvider } from 'primereact/api';
import { type ReactNode } from 'react';
import { Provider } from 'react-redux';

import { ThemeSync } from '@features/shell';
import { ConfirmHost, ToastProvider } from '@shared/components/base';

import { type AppStore } from '../store';

export function AppProviders({ store, children }: { store: AppStore; children: ReactNode }) {
  return (
    <Provider store={store}>
      <PrimeReactProvider value={{ ripple: false }}>
        <ToastProvider>
          <ThemeSync />
          <ConfirmHost />
          {children}
        </ToastProvider>
      </PrimeReactProvider>
    </Provider>
  );
}
